import React from "react";
import BackgroundImage from "gatsby-background-image";

import { PollenConsultCtaBanner } from "@types";
import PrimaryButtonWithArrow from "../../Buttons/PrimaryButtonWithArrow/PrimaryButtonWithArrow";

import styles from "./PollenConsultBanner.module.scss";

type PollenConsultBannerType = {
  banner: PollenConsultCtaBanner;
};

const PollenConsultBanner: React.FC<PollenConsultBannerType> = ({ banner }) => {
  const imageBgData =
    banner?.consultCtaImageBackground?.localFile.childImageSharp.fluid;

  return (
    <section className="full-width">
      <BackgroundImage
        Tag="section"
        fluid={imageBgData}
        className={styles.consultBanner}
        data-testid="div:PollenConsultBanner"
      >
        <p className={styles.consultarBannerHeadLine}>
          {banner?.consultCtaHeadline}
        </p>

        <PrimaryButtonWithArrow
          buttonText={banner?.consultCtaText}
          buttonLink={banner?.consultCtaLink}
          className={styles.consultBannerButton}
        />
      </BackgroundImage>
    </section>
  );
};

export default PollenConsultBanner;
